import { getAuthTokens } from '@/storage/auth-tokens.storage';
import { authStore, resolveAuthenticatedUser } from '@/store/auth.store';
import { getLogger } from '@/logger/logger';

const logger = getLogger('auth.init');

export async function initializeAuth(): Promise<void> {
  const tokens = getAuthTokens();

  if (!tokens?.access_token) {
    logger.info('Session initialization finished', {
      auth: { event: 'session_initialized', outcome: 'no_token' },
    });
    authStore.setState({ authStatus: 'unauthenticated' });
    return;
  }

  authStore.setState({ authStatus: 'loading' });

  try {
    await resolveAuthenticatedUser(tokens.access_token);
    const state = authStore.getState();
    if (state.authenticatedUser) {
      logger.info('Session initialization finished', {
        auth: { event: 'session_initialized', outcome: 'authenticated' },
      });
    } else {
      logger.warn('Session initialization finished', {
        auth: { event: 'session_initialized', outcome: 'no_user_returned' },
      });
      authStore.setState({ authStatus: 'unauthenticated' });
    }
  } catch (error) {
    logger.error('Session initialization finished', {
      auth: { event: 'session_initialized', outcome: 'failed' },
      error,
    });
    authStore.setState({ authStatus: 'unauthenticated' });
  }
}
